import {observer} from "mobx-react";
import {XCloseSmallIcon} from "../../assets/svg/x-close-small.icon";
import React from "react";
import styled from "styled-components";
import {ISideMenuControllerViewModel} from "../../services/side-menu/side-menu-controller.view-model.interface";

const CloseSideMenuButtonBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    color: ${props => props.theme.colors.medium};
    cursor: pointer;
`

export const CloseSideMenuButtonComponent: React.FC<{sideMenuController: ISideMenuControllerViewModel}> = observer((props) => {
    return (
        <CloseSideMenuButtonBox onClick={() => props.sideMenuController.close()}>
            <XCloseSmallIcon size={2.3}/>
        </CloseSideMenuButtonBox>
    );
})